import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { AuthStore } from '@core/auth';
import { DeviceService } from '@core/device';
import { I18nPipe, I18nService } from '@core/i18n';

import { AvatarComponent, InitialsPipe } from '@shared/avatar';
import { ButtonComponent } from '@shared/button';
import { MenuComponent, type MenuItem, MenuTriggerDirective } from '@shared/menu';

import { HEADER_PROFILE_MENU_OFFSET_PX } from '../header.types';

@Component({
  selector: 'ml-profile-menu',
  imports: [
    AvatarComponent,
    InitialsPipe,
    ButtonComponent,
    I18nPipe,
    MenuComponent,
    MenuTriggerDirective,
    TitleCasePipe,
  ],
  host: { class: 'contents' },
  templateUrl: './profile-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileMenuComponent {
  private readonly authStore = inject(AuthStore);
  private readonly i18n = inject(I18nService);
  protected readonly isCompact = inject(DeviceService).isMobileUI;
  protected readonly menuOffset = HEADER_PROFILE_MENU_OFFSET_PX;

  protected readonly profileItems: readonly MenuItem[] = [
    { value: 'profile', labelKey: 'header.profile.myProfile', icon: 'person' },
    {
      value: 'notification-settings',
      labelKey: 'header.profile.notificationSettings',
      icon: 'bell',
    },
    { kind: 'separator' },
    { value: 'logout', labelKey: 'header.profile.logout', icon: 'logout', destructive: true },
  ];

  protected readonly user = this.authStore.user;

  protected readonly displayName = computed(() => {
    this.i18n.currentLang();
    const user = this.user();
    const fullName = [user?.firstName?.trim(), user?.lastName?.trim().split(/\s+/)[0]]
      .filter(Boolean)
      .join(' ');

    return (
      [fullName, user?.username].find(Boolean) ?? this.i18n.instant('home.welcomeFallbackName')
    );
  });

  protected onSelect(value: string): void {
    if (value === 'logout') {
      this.authStore.endSession('manual');
    }
  }
}
